import React from "react";
import { CardContent, CardHeader, CardTitle } from "@/components/ui/card";
import { CompaniesTable } from "./CompaniesTable";
import type { Company } from "@/types/company";

interface CompanyTableWrapperProps {
  companies: Company[];
  onEdit: (company: Company) => void;
}

export const CompanyTableWrapper = ({ companies, onEdit }: CompanyTableWrapperProps) => {
  return (
    <>
      <CardHeader>
        <CardTitle>Empresas Cadastradas</CardTitle>
      </CardHeader>
      <CardContent>
        <CompaniesTable companies={companies} onEdit={onEdit} />
      </CardContent>
    </>
  );
};